/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { lpInspectionResultControllerOverwrite } from '../fn/lp-inspection-result/lp-inspection-result-controller-overwrite';
import { LpInspectionResultControllerOverwrite$Params } from '../fn/lp-inspection-result/lp-inspection-result-controller-overwrite';
import { lpInspectionResultControllerRestore } from '../fn/lp-inspection-result/lp-inspection-result-controller-restore';
import { LpInspectionResultControllerRestore$Params } from '../fn/lp-inspection-result/lp-inspection-result-controller-restore';
import { lpInspectionResultControllerSearchOffset } from '../fn/lp-inspection-result/lp-inspection-result-controller-search-offset';
import { LpInspectionResultControllerSearchOffset$Params } from '../fn/lp-inspection-result/lp-inspection-result-controller-search-offset';
import { LpInspectionResultDto } from '../models/lp-inspection-result-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class LpInspectionResultService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `lpInspectionResultControllerSearchOffset()` */
  static readonly LpInspectionResultControllerSearchOffsetPath = '/api/lp-inspection-result/search/offset';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionResultControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionResultControllerSearchOffset$Response(params: LpInspectionResultControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionResultDto>;
}>> {
    return lpInspectionResultControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionResultControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionResultControllerSearchOffset(params: LpInspectionResultControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<LpInspectionResultDto>;
}> {
    return this.lpInspectionResultControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<LpInspectionResultDto>;
}>): OffsetPaginationDto & {
'items'?: Array<LpInspectionResultDto>;
} => r.body)
    );
  }

  /** Path part for operation `lpInspectionResultControllerOverwrite()` */
  static readonly LpInspectionResultControllerOverwritePath = '/api/lp-inspection-result/{id}';

  /**
   * LP검사 결과 수정.
   *
   * 단일 LP검사 결과를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionResultControllerOverwrite()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionResultControllerOverwrite$Response(params: LpInspectionResultControllerOverwrite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return lpInspectionResultControllerOverwrite(this.http, this.rootUrl, params, context);
  }

  /**
   * LP검사 결과 수정.
   *
   * 단일 LP검사 결과를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionResultControllerOverwrite$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  lpInspectionResultControllerOverwrite(params: LpInspectionResultControllerOverwrite$Params, context?: HttpContext): Observable<void> {
    return this.lpInspectionResultControllerOverwrite$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `lpInspectionResultControllerRestore()` */
  static readonly LpInspectionResultControllerRestorePath = '/api/lp-inspection-result/{id}/restore';

  /**
   * LP검사 결과 복원.
   *
   * 단일 LP검사 결과를 복원합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `lpInspectionResultControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionResultControllerRestore$Response(params: LpInspectionResultControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return lpInspectionResultControllerRestore(this.http, this.rootUrl, params, context);
  }

  /**
   * LP검사 결과 복원.
   *
   * 단일 LP검사 결과를 복원합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `lpInspectionResultControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  lpInspectionResultControllerRestore(params: LpInspectionResultControllerRestore$Params, context?: HttpContext): Observable<void> {
    return this.lpInspectionResultControllerRestore$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
